module.exports = __webpack_public_path__ + "static/media/jd_mobile_cover_video.b783e531.webm";